import { Component, EventEmitter, Input, OnChanges, OnInit,
    Output, SimpleChanges, TemplateRef } from '@angular/core';
import * as moment from 'moment';
import { DayTemplateContext } from './day-template-context';
import * as _ from 'lodash';

export interface WeekView {
    days: DayTemplateContext[];
}

interface MonthView {
    weeks: WeekView[];
    dayNames: string[];
}

@Component({
    selector: 'cln-calendar-month-view',
    template: require('./calendar-month-view.component.html'),
    styles: [require('./calendar-month-view.component.less')],
})
export class CalendarMonthViewComponent implements OnInit, OnChanges {
    @Input() dayTemplate: TemplateRef<DayTemplateContext>;
    @Input() startDate: moment.Moment = moment();
    @Input() selectedDate: moment.Moment;
    @Output() selectedDateChange = new EventEmitter<moment.Moment>();

    monthView: MonthView;
    viewDate: moment.Moment;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.startDate && changes.startDate.currentValue) {
            this.viewDate = this.startDate.clone();
            this.updateView();
        }
    }

    ngOnInit(): void {
        this.viewDate = this.startDate || moment();
        this.updateView();
    }

    updateView(): void {
        const firstDay = this.viewDate.clone().startOf('month').startOf('week');
        const startWeek = firstDay.week();
        const endWeek = startWeek + this.viewDate.clone().endOf('month').endOf('week').diff(firstDay, 'week');
        const currentMonth = this.viewDate.month();
        const weekDays = moment.weekdays().length;
        const dayNames = _.range(weekDays).map((_v, i) => moment().startOf('week').add(i, 'day').format('ddd'));

        const day = firstDay.clone();
        const weeks = _.range(startWeek, endWeek + 1).map(() => {
            return {
                days: _.range(weekDays).map(() => {
                    const date = day.clone();
                    const isCurrentMonth = date.month() === currentMonth;

                    day.add(1, 'days');
                    return <DayTemplateContext> {
                        date,
                        isCurrentMonth,
                    };
                }),
            };
        });

        this.monthView = {
            dayNames,
            weeks,
        };
    }

    onDayClicked(context: DayTemplateContext): void {
        this.selectedDate = context.date;
        this.selectedDateChange.emit(this.selectedDate.clone());
    }

    isDayVisible(context: DayTemplateContext): boolean {
        return context.isCurrentMonth;
    }

    isSelected(date: moment.Moment): boolean {
        return this.selectedDate ? this.selectedDate.isSame(date, 'day') : false;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/calendar/calendar/calendar-month-view/calendar-month-view.component.ts